<template>
  <QuadroPrincipal
    v-if="mostraAlerta"
    borderTop
    :key="getRenderKey"
    :classe="classe"
    class="quadro-alerta"
  >
    <!-- <AlertaZfm class="espacamento" v-if="alerta" :alerta="alerta" /> -->
    <AlertaInstrucaoNormativa
      class="espacamento"
      v-if="!!alertas.length"
      :alinharAlertas="alinharAlertas"
    />
    <AlertaIncidenciaSimultanea
      v-if="existeAlerta"
      class="espacamento"
      :classe="classe"
      :textoAlerta="textoAlerta"
      :existeSt="existeSt"
      :existeAntecipacao="existeAntecipacao"
      :existeCargaLiquida="existeCargaLiquida"
      :existeDifal="existeDifal"
    />
  </QuadroPrincipal>
</template>

<script>
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";

import { mapGetters } from "vuex";
import AlertaIncidenciaSimultanea from "./AlertaIncidenciaSimultanea.vue";
import AlertaInstrucaoNormativa from "./AlertaInstrucaoNormativa.vue";
import AlertaZfm from "./AlertaZfm.vue";
export default {
  name: "QuadroAlerta",

  props: {
    classe: String,
    dadosForm: Array | Object,
    tipo: String,
    alerta: Array | Object
  },

  components: {
    QuadroPrincipal,
    Notificacao,
    AlertaZfm,
    AlertaInstrucaoNormativa,
    AlertaIncidenciaSimultanea
  },

  data() {
    return {
      // TEXTO QUE EXIBE PARA INCIDÊNCIA SIMULTÂNEA NA ABA DE ST
      ferramenta: {
        icms_interno: 9,
        icms_st: 10,
        carga_liquida: 11,
        antecipacao: 12,
        difal: 13,
        exportacao: 14,
        class_importacao: 15,
        ipi: 16,
        valida_equiparacao_industrial: 16,
        pis_cofins: 17,
        cide_combustivel: 18,
        defesa_comercial: 19
      }
    };
  },

  mounted() {
    this.$emit("exibeAlerta", this.mostraAlerta);
  },

  watch: {
    mostraAlerta() {
      this.$emit("exibeAlerta", this.mostraAlerta);
    }
  },

  computed: {
    ...mapGetters("alertas", ["getAlertas"]),
    ...mapGetters("resultado", ["getPossiveisAbas"]),
    ...mapGetters("reRender", ["getRenderKey"]),

    // TEXTO QUE EXIBE PARA INCIDÊNCIA SIMULTÂNEA NAS ABAS QUE NÃO SÃO DE ST
    textoAlerta() {
      switch (this.classe) {
        case "carga_liquida":
          return "Na hipótese de ocorrer a incidência de Substituição Tributária (ICMS ST), atendidos os critérios da legislação e, desde que observadas suas exceções, desconsiderar o resultado da aba Carga Líquida.";

        case "antecipacao":
          return "Atendidos os requisitos de enquadramento da Substituição Tributária (ICMS ST), desconsiderar o resultado da aba Antecipação Com Encerramento, exceto nos casos em que houver disposição contrária prevista na legislação.";

        case "difal":
          return "Atendidos os requisitos de enquadramento da Substituição Tributária (ICMS ST), desconsiderar o resultado da aba Diferencial de Alíquotas Contribuinte, exceto nos casos em que houver disposição contrária prevista na legislação.";

        default:
          return "erro";
      }
    },
    existeSt() {
      return this.getPossiveisAbas.includes("ICMS_ST");
    },
    existeAntecipacao() {
      return this.getPossiveisAbas.includes("ICMS_ANTECIPACAO_TRIBUTARIA");
    },
    existeCargaLiquida() {
      return this.getPossiveisAbas.includes("ICMS_CARGA_LIQUIDA");
    },
    existeDifal() {
      return this.getPossiveisAbas.includes("ICMS_DIFERENCIAL_DE_ALIQUOTAS");
    },
    alertas() {
      return this.getAlertas ? this.filtrarAlertas(this.getAlertas) : [];
      // return []
    },
    existeAlerta() {
      let abas = [
        "ICMS_CARGA_LIQUIDA",
        "ICMS_ANTECIPACAO_TRIBUTARIA",
        "ICMS_DIFERENCIAL_DE_ALIQUOTAS"
      ];
      let classe = ["icms_st", "carga_liquida", "antecipacao", "difal"];
      let inclui =
        this.getPossiveisAbas.some(imposto => abas.includes(imposto)) &&
        this.existeSt &&
        classe.includes(this.classe);
      return inclui;
    },
    alinharAlertas() {
      // Alinha alertas no mesmo bloco
      let alertasAlinhados = "";
      for (let index = 0; index < this.alertas.length; index++) {
        if (index < this.alertas.length - 1) {
          alertasAlinhados = alertasAlinhados + this.alertas[index].alerta + "</br></br>";
        } else {
          alertasAlinhados = alertasAlinhados + this.alertas[index].alerta;
        }
      }
      return alertasAlinhados;
    },
    mostraAlerta() {
      return !!this.alertas.length || this.existeAlerta;
    }
  },

  methods: {
    filtrarAlertas(alertas) {
      if (!alertas) {
        return;
      }

      let idFerramenta = this.ferramenta[this.classe];
      let blSN =
        this.dadosForm.regimeDestinatario == "32" || this.dadosForm.regimeRemetente == "32"
          ? true
          : false;
      let idEstado = [
        this.dadosForm.ufDestino ? +this.dadosForm.ufDestino : 0,
        this.dadosForm.ufOrigem ? +this.dadosForm.ufOrigem : 0
      ];

      let alertasFiltrados = [];
      alertas.forEach(alerta => {
        let ferramentasValidas = false;
        let estadosValidos = false;
        if (alerta.ferramentas.includes(idFerramenta)) {
          ferramentasValidas = true;
        }
        if (idEstado && alerta.estados.some(p => idEstado.includes(p))) {
          estadosValidos = true;
        }
        // Simples Nacional
        if (blSN && alerta.ferramentas.includes(20)) {
          ferramentasValidas = true;
          estadosValidos = true;
        }
        if (ferramentasValidas && estadosValidos) {
          alertasFiltrados.push(alerta);
        }
      });

      return alertasFiltrados;
    }
  }
};
</script>

<style lang="scss" scoped>
// .quadro-alerta {
//   border-bottom: 0px;
// }

.espacamento {
  margin-bottom: 1rem;
  &:last-child {
    margin-bottom: 0;
  }
}
@media only print {
  .quadro-alerta {
    padding-bottom: 0;
    page-break-inside: avoid;
  }
}
</style>
